import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContaBancariaService, PagamentoService } from 'administrativo-lib';
import { AssinaturaService, FuncaoService, GlobalService, LoginContabil, ProgressoService, Relatorio } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoletimPagamento } from './boletim-pagamento';

@Component({
  selector: 'app-relatorio-tesouraria',
  templateUrl: './relatorio-tesouraria.component.html'
})
export class RelatorioTesourariaComponent implements OnInit, OnDestroy {

  public login: LoginContabil = new LoginContabil();
  public relatoriosSelect = 'BOLETIM_BANCO';
  public listaRelatorios: Array<any>;
  public dataCaixa: Date = new Date();
  public dataFinal: Date = new Date();
  protected unsubscribe: Subject<void> = new Subject();
  protected datepipe: DatePipe;

  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    private router: Router,
    private pagtoService: PagamentoService,
    protected funcaoService: FuncaoService,
    protected contaBancariaService: ContaBancariaService,
    protected progressoService: ProgressoService) {
    this.login = GlobalService.obterSessaoLogin();
    this.datepipe = new DatePipe('pt');
  }

  ngOnInit() {
    this.listaRelatorios = [
      { id: 'CONCILIACAO_BANCARIA', nome: 'CONCILIAÇÃO BANCÁRIA' },
      { id: 'BOLETIM_BANCO', nome: 'BOLETIM DE BANCOS' },
      { id: 'BOLETIM_CAIXA', nome: 'BOLETIM DE CAIXA DIÁRIO' },
      { id: 'BOLETIM_TESOURARIA', nome: 'BOLETIM DE TESOURARIA' },
      { id: 'BOLETIM_RECEITA', nome: 'BOLETIM DE ANALÍTICO DA RECEITA' },
      { id: 'BOLETIM_PAGAMENTO', nome: 'BOLETIM ANALÍTICO DE PAGAMENTOS' },
      { id: 'DIARIO_CAIXA', nome: 'DIÁRIO DE CAIXA' }
    ];
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  imprimirPdf() {
    if (this.relatoriosSelect === 'BOLETIM_BANCO') {
      this.imprimirBoletimBanco();
    } else if (this.relatoriosSelect === 'BOLETIM_CAIXA') {
      this.imprimirBoletimCaixa();
    } else if (this.relatoriosSelect === 'CONCILIACAO_BANCARIA') {
      this.imprimirConciliacaoBancaria();
    } else if (this.relatoriosSelect === 'DIARIO_CAIXA') {
      // this.imprimirDiarioCaixa();
    } else if (this.relatoriosSelect === 'BOLETIM_PAGAMENTO') {
      this.imprimirBoletimPagamento();
    }
  }

  private imprimirBoletimPagamento() {    
    const parametros: {} = {};
    if (this.dataCaixa) {
      parametros['data'] = this.datepipe.transform(this.dataCaixa, 'yyyy-MM-dd');
    }
    parametros['exercicio'] = this.login.exercicio.id;
    parametros['orgao'] = this.login.orgao.id;
    this.pagtoService.boletimPagamento(parametros).subscribe(lista => {

      this.pagtoService.numeroBoletim(
        String(this.funcaoService.converteDataSQL(this.dataCaixa.toLocaleDateString())), this.login.exercicio.id, this.login.orgao.id).subscribe(numero => {
          const bp = new BoletimPagamento();
          bp.numero = numero;
          bp.dataCaixa = this.dataCaixa;
          bp.imprimir(lista, this.login);    
        });

    });
  }

  private imprimirConciliacaoBancaria() {
    this.contaBancariaService.conciliacaoBancaria(this.login.exercicio.id, this.login.orgao.id,
      this.datepipe.transform(this.dataCaixa, 'yyyy-MM-dd'),
      this.datepipe.transform(this.dataFinal, 'yyyy-MM-dd')).pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado('EXTRATO CONTÁBIL', this.login.usuario.nome,
          this.login.orgao.nome, this.login.brasao,
          this.montarConteudoconciliacao(dados, this.dataCaixa, this.dataFinal),
          'portrait', 'EXTRATO CONTÁBIL',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          }, false);

      });

  }

  private imprimirBoletimBanco() {
    this.contaBancariaService.boletimBanco(this.login.exercicio.id, this.login.orgao.id,
      this.datepipe.transform(this.dataCaixa, 'yyyy-MM-dd'),
      this.datepipe.transform(this.dataFinal, 'yyyy-MM-dd')).pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado('BOLETIM DE BANCOS CONTÁBIL', this.login.usuario.nome,
          this.login.orgao.nome, this.login.brasao,
          this.montarConteudoBoletimBanco(dados),
          'portrait', 'BOLETIM DE BANCOS CONTÁBIL',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          }, false);

      });
  }

  private montarConteudoBoletimBanco(lista: any[]) {
    let retorno: {}[] = [];
    retorno.push({
      text: `REFERÊNCIA: ${this.datepipe.transform(this.dataCaixa, 'dd/MM/yyyy')} a ${this.datepipe.transform(this.dataFinal, 'dd/MM/yyyy')}`,
      alignment: 'center', fontSize: 10, lineHeight: 1.5
    })

    const conteudo = [];
    conteudo.push([
      { text: 'FICHA', fontSize: 8, alignment: 'center', bold: true, border: [true, true, true, true] },
      { text: 'DESCRIÇÃO', fontSize: 8, alignment: 'center', bold: true },
      { text: 'ANTERIOR', fontSize: 8, alignment: 'center', bold: true },
      { text: 'DEPÓSITO', fontSize: 8, alignment: 'center', bold: true },
      { text: 'RETIRADA', fontSize: 8, alignment: 'center', bold: true },
      { text: 'SALDO', fontSize: 8, alignment: 'center', bold: true, border: [true, true, true, true] },
    ]);
    for (const entidade of lista) {
      const registro = [];
      registro.push({ text: entidade.id, fontSize: 8, alignment: 'center', bold: false });
      registro.push({
        text: `${entidade.banco_nome} ${entidade.nome} ${entidade.numero_conta} ${entidade.digito_conta}`,
        fontSize: 8, alignment: 'left', bold: false
      });
      registro.push({
        text: this.funcaoService.convertToBrNumber(+entidade.saldo_anterior + +entidade.saldo_ano_anterior, 2),
        fontSize: 8, alignment: 'right', bold: false
      });
      registro.push({ text: this.funcaoService.convertToBrNumber(entidade.deposito, 2), fontSize: 8, alignment: 'right', bold: false });
      registro.push({ text: this.funcaoService.convertToBrNumber(entidade.retirada, 2), fontSize: 8, alignment: 'right', bold: false });
      registro.push({ text: this.funcaoService.convertToBrNumber(+entidade.saldo_atual  + +entidade.saldo_ano_anterior, 2), fontSize: 8, alignment: 'right', bold: false });
      conteudo.push(registro);
    }
    const totais = this.funcaoService.totalizar(lista, ['saldo_ano_anterior', 'saldo_anterior', 'deposito', 'retirada', 'saldo_atual']);
    const total = [];
    total.push({ text: 'TOTAL', fontSize: 8, alignment: 'left', bold: true, colSpan: 1 });
    total.push('');
    total.push({ text: this.funcaoService.convertToBrNumber(+totais['saldo_anterior'] + +totais['saldo_ano_anterior'], 2), fontSize: 8, alignment: 'right', bold: true });
    total.push({ text: this.funcaoService.convertToBrNumber(totais['deposito'], 2), fontSize: 8, alignment: 'right', bold: true });
    total.push({ text: this.funcaoService.convertToBrNumber(totais['retirada'], 2), fontSize: 8, alignment: 'right', bold: true });
    total.push({ text: this.funcaoService.convertToBrNumber(+totais['saldo_atual'] + +totais['saldo_ano_anterior'], 2), fontSize: 8, alignment: 'right', bold: true });
    conteudo.push(total);
    retorno.push({
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 1,
        widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'],
        body: conteudo
      }
    });

    return retorno;
  }

  private imprimirBoletimCaixa() {
    this.contaBancariaService.boletimCaixa(this.login.exercicio.id, this.login.orgao.id,
      this.datepipe.transform(this.dataCaixa, 'yyyy-MM-dd')).pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado('BOLETIM DE CAIXA DIÁRIO', this.login.usuario.nome,
          this.login.orgao.nome, this.login.brasao,
          this.montarConteudoBoletimCaixa(dados),
          'portrait', 'BOLETIM DE CAIXA DIÁRIO',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          }, false);

      });
  }

  private montarConteudoBoletimCaixa(dados: any) {
    let retorno: {}[] = [];
    retorno.push({
      text: `DATA: ${this.datepipe.transform(this.dataCaixa, 'dd/MM/yyyy')}`, alignment: 'center', fontSize: 10, lineHeight: 1.5
    })
    const conteudo = [];
    conteudo.push([
      { text: 'CAIXA', fontSize: 12, alignment: 'center', bold: true, border: [true, true, true, true], colSpan: 2 }, ''
    ]);
    conteudo.push([
      { text: 'SALDO DO DIA ANTERIOR', fontSize: 10, alignment: 'left', bold: true, border: [true, true, true, true], lineHeight: 1.5 },
      { text: this.funcaoService.convertToBrNumber(dados.saldo_anterior_dia), fontSize: 10, alignment: 'right', bold: true, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'ENTRADAS DO DIA', fontSize: 10, alignment: 'left', bold: true, border: [true, true, true, true], colSpan: 2 }, ''
    ]);
    conteudo.push([
      { text: 'Receitas Orçamentárias', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.receitas_orcamentarias), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Receitas Extra - orçamentárias', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.receitas_extras), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Interveniências Ativas', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.interveniencias_ativas), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Retiradas de Bancos', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.retiradas_bancos), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Anulação de Pagamentos', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.anulacao_pagamentos), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    const total_entradas: number = +dados.receitas_orcamentarias + +dados.receitas_extras + +dados.interveniencias_ativas + +dados.retiradas_bancos + +dados.anulacao_pagamentos;
    conteudo.push([
      { text: 'TOTAL DE ENTRADAS', fontSize: 10, alignment: 'left', bold: true, border: [true, true, true, true], lineHeight: 1.5 },
      {
        text: this.funcaoService.convertToBrNumber(total_entradas),
        fontSize: 11, alignment: 'right', bold: true, border: [true, true, true, true]
      }
    ]);
    conteudo.push([
      { text: 'SAÍDAS DO DIA', fontSize: 10, alignment: 'left', bold: true, border: [true, true, true, true], colSpan: 2 }, ''
    ]);
    conteudo.push([
      { text: 'Pagamentos Orçamentários', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.pagamentos_orcamentarios), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Pagamentos Extra - orçamentários', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.pagamentos_extras), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Interveniências Passivas', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.interveniencias_passivas), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Depósitos em Bancos', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.depositos_bancos), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Anulação de Receitas', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.anulacao_receitas), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    const total_saidas: number = +dados.pagamentos_orcamentarios + +dados.pagamentos_extras + +dados.interveniencias_passivas + +dados.depositos_bancos + +dados.anulacao_receitas;
    conteudo.push([
      { text: 'TOTAL DE SAÍDAS', fontSize: 10, alignment: 'left', bold: true, border: [true, true, true, true], lineHeight: 1.5 },
      {
        text: this.funcaoService.convertToBrNumber(total_saidas),
        fontSize: 10, alignment: 'right', bold: true, border: [true, true, true, true]
      }
    ]);
    const saldo_caixa = (+dados.saldo_anterior_dia + +total_entradas) - +total_saidas;
    conteudo.push([
      { text: 'SALDO EM CAIXA', fontSize: 10, alignment: 'left', bold: true, border: [true, true, true, true], lineHeight: 1.5 },
      { text: this.funcaoService.convertToBrNumber(+saldo_caixa), fontSize: 10, alignment: 'right', bold: true, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'BANCOS', fontSize: 12, alignment: 'center', bold: true, border: [true, true, true, true], colSpan: 2 }, ''
    ]);
    conteudo.push([
      { text: 'SALDO ANTERIOR DE BANCOS', fontSize: 10, alignment: 'left', bold: true, border: [true, true, true, true], lineHeight: 1.5 },
      { text: this.funcaoService.convertToBrNumber(dados.saldo_anterior_banco), fontSize: 10, alignment: 'right', bold: true, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Depósitos do Dia', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.depositos_bancos), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'Retiradas do Dia', fontSize: 10, alignment: 'left', bold: false, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(dados.retiradas_bancos), fontSize: 10, alignment: 'right', bold: false, border: [true, true, true, true] }
    ]);
    const saldo_banco = +dados.saldo_anterior_banco + (+dados.depositos_bancos - +dados.retiradas_bancos);
    conteudo.push([
      { text: 'SALDO EM BANCOS', fontSize: 10, alignment: 'left', bold: true, border: [true, true, true, true], lineHeight: 1.5 },
      { text: this.funcaoService.convertToBrNumber(+saldo_banco), fontSize: 10, alignment: 'right', bold: true, border: [true, true, true, true] }
    ]);
    conteudo.push([
      { text: 'DISPONIBILIDADE FINANCEIRA', fontSize: 10, alignment: 'left', bold: true, border: [true, true, true, true], lineHeight: 1.5 },
      { text: this.funcaoService.convertToBrNumber(+saldo_banco + +saldo_caixa), fontSize: 10, alignment: 'right', bold: true, border: [true, true, true, true] }
    ]);
    retorno.push({
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 1,
        widths: ['*', 200],
        body: conteudo
      }
    });

    return retorno;
  }

  private montarConteudoconciliacao(lista: any[], dataInicial: Date, dataFinal: Date) {
    const dados = this.funcaoService.agrupar(lista, ['id', 'nome', 'numero_conta', 'digito_conta', 'banco_nome', 'saldo_ano_anterior'], ['saldo_anterior']);

    let retorno: {}[] = [];
    retorno.push({ text: `REFERÊNCIA: ${this.datepipe.transform(dataInicial, 'dd/MM/yyyy')} a ${this.datepipe.transform(dataFinal, 'dd/MM/yyyy')}`, alignment: 'center', fontSize: 10, lineHeight: 1.5 });
    let primeiro = true;
    for (const entidade of dados) {
      const conteudo = [];
      conteudo.push([
        { text: 'DATA', fontSize: 8, alignment: 'center', bold: true, border: [true, true, true, true] },
        { text: 'HISTÓRICO', fontSize: 8, alignment: 'center', bold: true },
        { text: 'DOCUMENTO', fontSize: 8, alignment: 'center', bold: true },
        { text: 'DEPÓSITO', fontSize: 8, alignment: 'center', bold: true },
        { text: 'RETIRADA', fontSize: 8, alignment: 'center', bold: true },
        { text: 'SALDO', fontSize: 8, alignment: 'center', bold: true, border: [true, true, true, true] },
      ]);
      conteudo.push([
        { text: `CONTA: ${entidade.grupo['id']} ${entidade.grupo['banco_nome']} ${entidade.grupo['nome']} - ${entidade.grupo['numero_conta']} ${entidade.grupo['digito_conta']}`, fontSize: 10, alignment: 'left', bold: true, colSpan: 6 },
        '',
        '',
        '',
        '',
        ''
      ]);
      let saldo_anterior =  +entidade.grupo['saldo_ano_anterior'] + +entidade.totalizadores['saldo_anterior'];
      conteudo.push([
        { text: `SALDO ANTERIOR`, fontSize: 8, alignment: 'left', bold: true, colSpan: 2 },
        '',
        { text: this.funcaoService.convertToBrNumber(+saldo_anterior, 2), fontSize: 8, alignment: 'right', bold: true, colSpan: 4 },
        '',
        '',
        ''
      ]);
      for (const lancamento of entidade.registros) {
        const registro = [];
        registro.push({ text: this.datepipe.transform(lancamento.data, 'dd/MM/yyyy'), fontSize: 8, alignment: 'center', bold: false });
        registro.push({
          text: `${lancamento.historico}`,
          fontSize: 8, alignment: 'left', bold: false
        });
        registro.push({
          text: `${lancamento.documento}`,
          fontSize: 8, alignment: 'left', bold: false
        });
        saldo_anterior += +lancamento.deposito - +lancamento.retirada;
        registro.push({ text: this.funcaoService.convertToBrNumber(lancamento.deposito, 2), fontSize: 8, alignment: 'right', bold: false });
        registro.push({ text: this.funcaoService.convertToBrNumber(lancamento.retirada, 2), fontSize: 8, alignment: 'right', bold: false });
        registro.push({ text: this.funcaoService.convertToBrNumber(saldo_anterior, 2), fontSize: 8, alignment: 'right', bold: false });
        conteudo.push(registro);
      }
      const totais = this.funcaoService.totalizar(entidade.registros, ['deposito', 'retirada']);
      const total = [];
      total.push({ text: 'TOTAL', fontSize: 8, alignment: 'left', bold: true, colSpan: 3 });
      total.push('');
      total.push('');
      total.push({ text: this.funcaoService.convertToBrNumber(totais['deposito'], 2), fontSize: 8, alignment: 'right', bold: true });
      total.push({ text: this.funcaoService.convertToBrNumber(totais['retirada'], 2), fontSize: 8, alignment: 'right', bold: true });
      total.push({ text: this.funcaoService.convertToBrNumber(saldo_anterior, 2), fontSize: 8, alignment: 'right', bold: true });
      conteudo.push(total);
      retorno.push({
        layout: 'linhas',
        table: {
          dontBreakRows: true,
          headerRows: 1,
          widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'],
          body: conteudo
        }, pageBreak: 'before'
      });
      if (primeiro) {
        delete retorno[retorno.length - 1]['pageBreak'];
        primeiro = false;
      }
    }
    return retorno;
  }

  sair() {
    this.funcaoService.navegarPara(this.login.usuario.sistema, this.router);
  }

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
        this.router.navigate(['/tesouraria']);
        break;
      default:
        this.sair();
        break;
    }
  }
}
